// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { darkThemePalette, lightThemePalette } from 'theme/defaultThemes';
import { BrandingConfiguration } from '../theme.types';
import catMedia from '../../assets/catmedia.svg';

export const defaultBranding: BrandingConfiguration = {
  // start and end dates are irrelevant for the fallback theme
  startDate: new Date(),
  endDate: new Date(),
  fluentTheme: {
    Light: lightThemePalette,
    Dark: darkThemePalette
  },
  catImage: catMedia.toString(),
  welcomeMessages: {
    morning: 'Good morning',
    afternoon: 'Good afternoon',
    evening: 'Good evening',
    night: 'Zzzz'
  },
  soundEffects: [
    {
      soundName: 'applause',
      displayText: 'Applause',
      durationMs: 1040,
      icon: 'ApplauseSound'
    },
    {
      soundName: 'cheers-yes',
      displayText: 'Yes!',
      durationMs: 470,
      icon: 'YesSound'
    },
    {
      soundName: 'wow',
      displayText: 'Wow!',
      durationMs: 1430,
      icon: 'WowSound'
    },
    {
      soundName: 'elevatormusic',
      displayText: 'Elevator',
      durationMs: 254000,
      icon: 'ElevatorSound'
    },
    {
      soundName: 'laughter',
      displayText: 'laughter',
      durationMs: 6000,
      icon: 'WowSound'
    },
    {
      soundName: 'laughter-seinfeld',
      displayText: 'laughter-seinfeld',
      durationMs: 12000,
      icon: 'WowSound'
    },
    {
      soundName: 'wow-anime',
      displayText: 'Wow (Anime)',
      durationMs: 3000,
      icon: 'WowSound'
    },
    {
      soundName: 'wow-owen-wilson',
      displayText: 'Wow (Owen Wilson)',
      durationMs: 39000,
      icon: 'WowSound'
    }
  ],
  lobbySoundUrl: './audios/lobbyMusicPlaceholder.mp3',
  videoBackgrounds: [
    {
      key: 'ab1',
      url: '/backgrounds/contoso.png',
      tooltipText: 'Custom Background'
    },
    {
      key: 'ab2',
      url: '/backgrounds/abstract2.jpg',
      tooltipText: 'Custom Background'
    },
    {
      key: 'ab3',
      url: '/backgrounds/abstract3.jpg',
      tooltipText: 'Custom Background'
    },
    {
      key: 'ab4',
      url: '/backgrounds/room1.jpg',
      tooltipText: 'Custom Background'
    },
    {
      key: 'ab5',
      url: '/backgrounds/room2.jpg',
      tooltipText: 'Custom Background'
    },
    {
      key: 'ab6',
      url: '/backgrounds/room3.jpg',
      tooltipText: 'Custom Background'
    },
    {
      key: 'ab7',
      url: '/backgrounds/room4.jpg',
      tooltipText: 'Custom Background'
    }
  ],
  noMeetingsEmoji: '🎉'
};
